import { render, staticRenderFns } from "./tabs.html?vue&type=template&id=d4bc065c&scoped=true&"
import script from "./tabs.js?vue&type=script&lang=js&"
export * from "./tabs.js?vue&type=script&lang=js&"
import style0 from "./tabs.scss?vue&type=style&index=0&id=d4bc065c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bc065c",
  null
  
)

export default component.exports